import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { appendFeature, destroyFeature, toggleFeature } from '../../../taking/learnosity';
export var LearnosityCalculator = /*#__PURE__*/function (_Component) {
  function LearnosityCalculator() {
    var _this;
    _classCallCheck(this, LearnosityCalculator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LearnosityCalculator, [].concat(args));
    _defineProperty(_this, "state", {
      learnosityCalculatorReady: false,
      featureId: _this.props.featureId || "calc_".concat(new Date().getTime())
    });
    _defineProperty(_this, "handleClick", function () {
      _this.toggle();
      _this.props.setActiveCalculatorId(_this.state.featureId);
    });
    return _this;
  }
  _inherits(LearnosityCalculator, _Component);
  return _createClass(LearnosityCalculator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.calculatorType !== 'none') {
        this.initializeLearnosity();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyLearnosity();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.calculatorType !== 'none' && (prevProps.calculatorType === 'none' || this.props.quizSessionId && !prevProps.quizSessionId)) {
        this.initializeLearnosity();
      } else if (this.props.calculatorType === 'none' && prevProps.calculatorType !== 'none') {
        this.destroyLearnosity();
      } else if (this.props.activeCalculatorId !== prevProps.activeCalculatorId && this.props.activeCalculatorId !== this.state.featureId) {
        this.toggle(false);
      }
    }
  }, {
    key: "initializeLearnosity",
    value: function () {
      var _initializeLearnosity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.props.quizSessionId) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return this.props.appendFeature(this.props.quizSessionId, {
                type: 'calculator',
                mode: this.props.calculatorType,
                feature_id: this.state.featureId
              });
            case 4:
              if (!(this.props.calculatorType === 'none')) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              this.setState({
                learnosityCalculatorReady: true
              });
              this.props.setCalculatorEnabled(true);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initializeLearnosity() {
        return _initializeLearnosity.apply(this, arguments);
      }
      return initializeLearnosity;
    }()
  }, {
    key: "destroyLearnosity",
    value: function destroyLearnosity() {
      this.props.destroyFeature(this.state.featureId);
    }
  }, {
    key: "toggle",
    value: function toggle(onOff) {
      this.props.toggleFeature(this.state.featureId, onOff);
    }
  }, {
    key: "renderCalculator",
    value: function renderCalculator() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.render({
        toggleCalculator: this.handleClick,
        enabled: this.state.learnosityCalculatorReady,
        iceTopNavBarEnabled: this.props.iceTopNavBarEnabled
      }), /*#__PURE__*/React.createElement("div", {
        hidden: true
      }, /*#__PURE__*/React.createElement("span", {
        className: "learnosity-feature feature-".concat(this.state.featureId)
      })));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.quizSessionId || this.props.calculatorType === 'none') {
        return null;
      }
      return this.renderCalculator();
    }
  }]);
}(Component);
_defineProperty(LearnosityCalculator, "propTypes", {
  activeCalculatorId: PropTypes.string,
  appendFeature: PropTypes.func.isRequired,
  calculatorType: PropTypes.oneOf(['none', 'basic', 'scientific']),
  destroyFeature: PropTypes.func.isRequired,
  featureId: PropTypes.string,
  quizSessionId: PropTypes.string,
  render: PropTypes.func.isRequired,
  setActiveCalculatorId: PropTypes.func,
  toggleFeature: PropTypes.func.isRequired,
  iceTopNavBarEnabled: PropTypes.bool,
  setCalculatorEnabled: PropTypes.func
});
_defineProperty(LearnosityCalculator, "defaultProps", {
  activeCalculatorId: null,
  appendFeature: appendFeature,
  calculatorType: 'none',
  destroyFeature: destroyFeature,
  featureId: null,
  quizSessionId: null,
  setActiveCalculatorId: Function.prototype,
  toggleFeature: toggleFeature,
  iceTopNavBarEnabled: false,
  setCalculatorEnabled: function setCalculatorEnabled() {}
});
export default LearnosityCalculator;